import { FC, useMemo } from "react";
import { Stack, Tooltip, Typography } from "@mui/material";
import { useShallow } from "zustand/shallow";

import { useKpisStore } from "stores/kpis.store";
import { KpiPercentIndicatorCircle } from "components/PercentIndicatorCircle/KpiPercentIndicatorCircle";
import { useSitesProgressQuery } from "hooks/queries/kpis";

export const KpisHeader: FC = (): JSX.Element => {
  const { selectedSite } = useKpisStore(
    useShallow(store => ({
      selectedSite: store.selectedSite
    }))
  );

  const {
    isLoading: isSitesLoading,
    isError: isSitesError,
    data: sites
  } = useSitesProgressQuery({ page: 1, size: 999_999, ordering: "-year" });

  const percent = useMemo(() => {
    if (!isSitesLoading && !isSitesError && sites) {
      return (
        sites.results.find(
          site =>
            site.id === selectedSite?.id && site.year === selectedSite?.year
        )?.progress.percentage_metric ?? 0
      );
    }

    return 0;
  }, [isSitesLoading, isSitesError, selectedSite, sites]);

  if (!selectedSite) {
    return <></>;
  }

  return (
    <>
      <Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Tooltip title={selectedSite?.name} placement="bottom-start">
            <Typography
              variant="h4"
              component="h2"
              flexShrink={1}
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",
                whiteSpace: "wrap",
                width: "calc(100% - 150px)",
                fontSize: "1.8rem"
              }}
            >
              {selectedSite?.name}
            </Typography>
          </Tooltip>
          <Stack
            justifyContent="space-between"
            direction="row"
            flexGrow={0}
            alignItems="center"
            spacing={2}
          >
            <KpiPercentIndicatorCircle
              percent={percent}
              size={40}
              strokeWidth={4}
            />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
